module.exports = __webpack_public_path__ + "img/10coin@2x.8b639237.png";